import { GetStaticProps, GetStaticPaths } from 'next';
import dynamic from 'next/dynamic';

import { getArticlesPageStaticProps } from 'services/staticGeneration/articlesPage';
import { getArticlePageStaticPaths } from 'services/incrementalStaticGeneration/articlesPage';

const DynamicArticle = dynamic(() => import('./DynamicArticle'), {
  ssr: false,
});

export const getStaticProps: GetStaticProps = getArticlesPageStaticProps;
export const getStaticPaths: GetStaticPaths = getArticlePageStaticPaths;

export default DynamicArticle;
